module.exports = __webpack_public_path__ + "img/1618635825.79279acc.png";